import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import axios from "axios";

import { IoMdClose, IoMdDownload } from "react-icons/io";

function chooseRenderMethod(type, url) {
  switch (type) {
    case "google":
      return (
        <iframe
          src={url}
          frameBorder="0"
          width="200%"
          height="450px"
          className="overflow-auto"
        ></iframe>
      );
    case "konveio":
    case "office":
    case "embed":
      return (
        <iframe src={url} frameBorder="0" width="100%" height="450px"></iframe>
      );

    default:
      return (
        <DocViewer
          prefetchMethod="GET"
          documents={[{ uri: url }]}
          pluginRenderers={DocViewerRenderers}
          config={{
            header: {
              disableHeader: true,
              disableFileName: true,
            },
            pdfZoom: {
              defaultZoom: 1.3,
            },
          }}
        />
      );
      break;
  }
}

function MobileEmbedViewer({ urlFile, isVisible }) {
  const handleDownload = () => {
    axios({
      url: urlFile?.fileUrl,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${urlFile.fileName}.pdf`); // Specify the desired filename and extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading the file:", error);
      });
  };
  return (
    <div>
      <div className="flex items-center justify-between border-b border-slate-400 px-2 py-0.5 text-xs">
        <div className="flex">
          {urlFile?.fileType === "pdf" && (
            <button
              className="flex px-2 py-0.5 rounded-md items-center justify-evenly bg-blue-600 text-blueGray-200 hover:bg-blue-400 transform duration-200 focus:outline-none"
              onClick={() => handleDownload(urlFile)}
            >
              <IoMdDownload className="h-5 w-5 text-blueGray-200 cursor-pointer p-0 md:p-1" />
            </button>
          )}
          <p className="text-black ml-4 py-1.5">{urlFile?.fileName}</p>
        </div>
        <IoMdClose
          className="h-5 w-5 text-black cursor-pointer hover:text-slate-500 hover:rotate-180 transform duration-300"
          onClick={() => isVisible(false)}
        />
      </div>
      <div className="grow bg-white overflow-auto">
        {chooseRenderMethod(urlFile?.fileType, urlFile?.fileUrl)}
      </div>
    </div>
  );
}

export default MobileEmbedViewer;
